import React, { useEffect, useState } from 'react';
import { Row, Col, Select, InputNumber, Switch, notification } from 'antd';
import { cloneDeep } from 'lodash';
import { yanfeiMz, yanfeiSyw, yanfeiWeapon, teammates } from '../../yanfei.data';
import type { YanfeiAttr, YanfeiConfig, TeammateConfig, EnemyConfig } from '../../types';
import styles from './index.module.css';

const Yanfei: React.FC = () => {
    const [api, contextHolder] = notification.useNotification();
    const [zhuozhuo, setZhuozhuo] = useState<boolean>(true);
    const [damageCup, setDamageCup] = useState<boolean>(false);
    const [criticalBalance, setCriticalBalance] = useState<boolean>(true);
    const [talentCritical, setTalentCritical] = useState<boolean>(false);
    const [yanfeiAttr, setYanfeiAttr] = useState<YanfeiAttr>({
        atk: 2551,
        elemental: 161,
        criticalRate: 62.4,
        criticalDamage: 188.3,
    });
    const [yanfeiConfig, setYanfeiConfig] = useState<YanfeiConfig>({
        mz: '6命',
        syw: '4猎人',
        weapon: '精1金流',
    });
    const [teammatesConfig, setTeammatesConfig] = useState<TeammateConfig[]>([]);
    const [enemyConfig, setEnemyConfig] = useState<EnemyConfig>({
        level: 100,
        resistance: 10,
    });

    // 定义最终属性
    const finalAttr: Record<string, any> = {
        // 基础攻击力
        basicAtk: yanfeiMz[yanfeiConfig.mz].basicAtk,
        // 额外大攻击
        atkRate: 0,
        // 基础倍率
        basicRate: yanfeiMz[yanfeiConfig.mz].basicRate,
        // 基础乘区补足
        basicCount: 0,
        // 增幅额外倍率
        elementalRate: 1,
    };
    // 烟绯自身属性（攻击力，精通，暴击，暴伤）
    let {
        atk,
        elemental,
        criticalRate,
        criticalDamage,
    } = yanfeiAttr;
    finalAttr.atk = atk;
    finalAttr.elemental = elemental;
    finalAttr.criticalRate = criticalRate / 100;
    finalAttr.criticalDamage = criticalDamage / 100;
    if (talentCritical) {
        finalAttr.criticalRate += 0.2;
    }
    // finalAttr.criticalScore = (criticalRate * 2 + criticalDamage) / 100;
    finalAttr.damageRate = cloneDeep(yanfeiMz[yanfeiConfig.mz].damageRate);
    if (zhuozhuo) {
        finalAttr.damageRate.z += yanfeiMz[yanfeiConfig.mz].zz;
    }
    // 固定防御乘区
    finalAttr.defence = 90 / (90 + enemyConfig.level);
    // 怪物抗性
    finalAttr.resistance = enemyConfig.resistance / 100;
    // 烟绯圣遗物统计
    const sywData = yanfeiSyw[yanfeiConfig.syw] as Record<string, any>;
    for (const attr of Object.keys(sywData)) {
        if (finalAttr[attr]) {
            if (typeof sywData[attr] === 'number') {
                finalAttr[attr] += sywData[attr];
            } else {
                for (const subAttr of Object.keys(sywData[attr])) {
                    if (finalAttr[attr][subAttr]) {
                        finalAttr[attr][subAttr] += sywData[attr][subAttr];
                    } else {
                        finalAttr[attr][subAttr] = cloneDeep(sywData[attr][subAttr]);
                    }
                }
            }
        } else {
            finalAttr[attr] = cloneDeep(sywData[attr]);
        }
    }
    // 烟绯武器统计
    const weaponData = yanfeiWeapon[yanfeiConfig.weapon] as Record<string, any>;
    for (const attr of Object.keys(weaponData)) {
        if (finalAttr[attr]) {
            if (typeof weaponData[attr] === 'number') {
                finalAttr[attr] += weaponData[attr];
            } else {
                for (const subAttr of Object.keys(weaponData[attr])) {
                    if (finalAttr[attr][subAttr]) {
                        finalAttr[attr][subAttr] += weaponData[attr][subAttr];
                    } else {
                        finalAttr[attr][subAttr] = cloneDeep(weaponData[attr][subAttr]);
                    }
                }
            }
        } else {
            finalAttr[attr] = cloneDeep(weaponData[attr]);
        }
    }
    for (const tmConfig of teammatesConfig) {
        if (!tmConfig) {
            continue;
        }
        const teammateInfo = teammates[tmConfig.name];
        if (tmConfig.name === '班尼特') {
            const mzData = teammateInfo.mz[tmConfig.mz] as Record<string, any>;
            const wpData = teammateInfo.weapon[tmConfig.weapon] as Record<string, any>;
            const bntBasicAtk = mzData.selfAtk + wpData.selfAtk;
            finalAttr.atk += bntBasicAtk * mzData.selfAtkRate;
            finalAttr.atkRate += mzData.atkRate;
            if (mzData.damageRate) {
                for (const attr of Object.keys(mzData.damageRate)) {
                    finalAttr.damageRate[attr] += mzData.damageRate[attr];
                }
            }
            const sywTmData = teammateInfo.syw[tmConfig.syw] as Record<string, any>;
            for (const attr of Object.keys(sywTmData)) {
                if (!finalAttr[attr]) {
                    finalAttr[attr] = cloneDeep(sywTmData[attr]);
                } else {
                    if (typeof sywTmData[attr] === 'number') {
                        finalAttr[attr] += sywTmData[attr];
                    } else {
                        for (const subAttr of Object.keys(sywTmData[attr])) {
                            if (finalAttr[attr][subAttr]) {
                                finalAttr[attr][subAttr] += sywTmData[attr][subAttr];
                            } else {
                                finalAttr[attr][subAttr] = cloneDeep(sywTmData[attr][subAttr]);
                            }
                        }
                    }
                }
            }
        } else {
            const dataList: Record<string, any>[] = [
                cloneDeep(teammateInfo.mz[tmConfig.mz] as Record<string, any>) || {},
                cloneDeep(teammateInfo.weapon[tmConfig.weapon] as Record<string, any>) || {},
                cloneDeep(teammateInfo.syw[tmConfig.syw] as Record<string, any>) || {},
            ];
            for (const d of dataList) {
                for (const attr of Object.keys(d)) {
                    if (!finalAttr[attr]) {
                        finalAttr[attr] = cloneDeep(d[attr]);
                    } else {
                        if (typeof d[attr] === 'number') {
                            finalAttr[attr] += d[attr];
                        } else {
                            for (const subAttr of Object.keys(d[attr])) {
                                if (finalAttr[attr][subAttr]) {
                                    finalAttr[attr][subAttr] += d[attr][subAttr];
                                } else {
                                    finalAttr[attr][subAttr] = cloneDeep(d[attr][subAttr]);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    // 最终攻击
    finalAttr.atk += finalAttr.basicAtk * finalAttr.atkRate;
    if (damageCup) {
        finalAttr.atk -= finalAttr.basicAtk * 0.466;
        finalAttr.damageRate.a += 0.466;
        finalAttr.damageRate.e += 0.466;
        finalAttr.damageRate.q += 0.466;
        finalAttr.damageRate.z += 0.466;
        finalAttr.damageRate.x += 0.466;
    }
    // 最终增幅乘区
    finalAttr.elementalRate += finalAttr.elemental * 2.8 / (finalAttr.elemental + 1400);
    // 最终减抗乘区
    finalAttr.resistanceRate = finalAttr.resistance > 0 ? 1 - finalAttr.resistance : 1 - finalAttr.resistance / 2;
    // 最终双暴乘区和暴击伤害
    if (criticalBalance) {
        // 自动配平
        const criticalScore = finalAttr.criticalRate * 2 + finalAttr.criticalDamage;
        finalAttr.criticalCount = criticalScore >= 4 ? criticalScore - 1 : criticalScore * criticalScore / 8 + 1;
        if (criticalScore <= 4) {
            finalAttr.criticalRate = criticalScore / 4;
            finalAttr.criticalDamage = criticalScore / 2;    
        } else {
            finalAttr.criticalRate = 1;
            finalAttr.criticalDamage = criticalScore - 2;
        }
    } else {
        const criticalRate = Math.min(finalAttr.criticalRate, 1);
        const criticalDamage = finalAttr.criticalDamage;
        finalAttr.criticalCount = 1 + criticalRate * criticalDamage;
    }

    useEffect(() => {
        api.open({
            duration: 0,
            placement: 'top',
            message: '使用说明',
            description: (
                <div>
                    <div>1. 队友取班尼特时自动计算双火；</div>
                    <div>2. 计算茜特菈莉一命时取 1000 精通，计算希诺宁四命时取 3500 防御，计算芙宁娜带板砖时取 50000 生命，计算闲云时取 4500 攻击；</div>
                    <div>3. 计算圣遗物或武器时，没有自动屏蔽相同效果重复生效，例如勇者套效果无法叠加、苍古系列武器效果无法叠加，请在选择时手动规避；</div>
                    <div>4. 队友存在「闲云」或武器选择「溢彩」时计算伤害为下落伤害，否则为重击伤害；</div>
                    <div>5. 计算时丹火印自动取满；</div>
                    <div>6. 计算伤害仅为单次伤害，不考虑实际总伤与充能循环。</div>
                </div>
            ),
        });
    }, [api]);

    return (
        <div className={styles.pageWrapper}>
            {contextHolder}
            <div className={styles.background} />
            <Row gutter={[24, 24]} className={styles.contentRow}>
                <Col xs={24} md={8}>
                    <div className={styles.card}>
                        <div className={styles.title}>烟绯配置</div>
                        <div className={styles.subtitle}>
                            命座
                        </div>
                        <Select
                            value={yanfeiConfig.mz}
                            onChange={mz => setYanfeiConfig(c => ({ ...c, mz }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        >
                            {Object.keys(yanfeiMz).map(key => (
                                <Select.Option key={key} value={key}>{key}</Select.Option>
                            ))}
                        </Select>

                        <div className={styles.subtitle}>
                            武器
                        </div>
                        <Select
                            value={yanfeiConfig.weapon}
                            onChange={weapon => setYanfeiConfig(c => ({ ...c, weapon }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        >
                            {Object.keys(yanfeiWeapon).map(key => (
                                <Select.Option key={key} value={key}>{key}</Select.Option>
                            ))}
                        </Select>

                        <div className={styles.subtitle}>
                            圣遗物
                        </div>
                        <Select
                            value={yanfeiConfig.syw}
                            onChange={syw => setYanfeiConfig(c => ({ ...c, syw }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        >
                            {Object.keys(yanfeiSyw).map(key => (
                                <Select.Option key={key} value={key}>{key}</Select.Option>
                            ))}
                        </Select>

                        <div className={styles.subtitle}>
                            单人面板属性
                        </div>
                        <InputNumber
                            prefix={'攻击'}
                            min={0}
                            value={yanfeiAttr.atk}
                            onChange={atk => setYanfeiAttr(c => ({ ...c, atk: atk ?? 0 }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                        <InputNumber
                            prefix={'精通'}
                            min={0}
                            value={yanfeiAttr.elemental}
                            onChange={elemental => setYanfeiAttr(c => ({ ...c, elemental: elemental ?? 0 }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                        <InputNumber
                            prefix={'暴击率'}
                            suffix={'%'}
                            min={0}
                            value={yanfeiAttr.criticalRate}
                            onChange={criticalRate => setYanfeiAttr(c => ({ ...c, criticalRate: criticalRate ?? 0 }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                        <InputNumber
                            prefix={'暴击伤害'}
                            suffix={'%'}
                            min={0}
                            value={yanfeiAttr.criticalDamage}
                            onChange={criticalDamage => setYanfeiAttr(c => ({ ...c, criticalDamage: criticalDamage ?? 0 }))}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                        <div className={styles.subtitle}>
                            灼灼
                        </div>
                        <Switch checked={zhuozhuo} onChange={() => setZhuozhuo(!zhuozhuo)} />
                        <div className={styles.subtitle}>
                            攻击杯转火伤杯
                        </div>
                        <Switch checked={damageCup} onChange={() => setDamageCup(!damageCup)} />
                        <div className={styles.subtitle}>
                            双暴自动配平
                        </div>
                        <Switch checked={criticalBalance} onChange={() => setCriticalBalance(!criticalBalance)} />
                        <div className={styles.subtitle}>
                            天赋暴击+20%
                        </div>
                        <Switch checked={talentCritical} onChange={() => setTalentCritical(!talentCritical)} />
                    </div>
                </Col>
                <Col xs={24} md={8}>
                    <div className={styles.card}>
                        <div className={styles.title}>队友配置</div>
                        {
                            [0, 0, 0].map((_item, index) => {
                                const tmCfg = teammatesConfig[index];
                                const standbyTeammateNames = Object.keys(teammates).filter(t => !teammatesConfig.map(c => c.name).includes(t));
                                return (
                                    <div>
                                        <div className={styles.subtitle}>
                                            队友 {index + 1}：{teammatesConfig[index]?.name || '未选择'}
                                        </div>
                                        <Select
                                            prefix={'角色：'}
                                            className={styles.select}
                                            style={{ width: '100%' }}
                                            value={teammatesConfig[index]?.name || '未选择'}
                                            onChange={(name: string) => {
                                                const newTeammatesConfig = [...teammatesConfig];
                                                newTeammatesConfig[index] = {
                                                    name,
                                                    ...teammates[name].defaultConfig,
                                                };
                                                setTeammatesConfig(newTeammatesConfig);
                                            }}
                                        >
                                            {standbyTeammateNames.map(key => (
                                                <Select.Option key={key} value={key}>{key}</Select.Option>
                                            ))}
                                        </Select>
                                        {
                                            !tmCfg ? null : (
                                                <>
                                                    <Select
                                                        prefix={'命座：'}
                                                        className={styles.select}
                                                        style={{ width: '100%' }}
                                                        value={tmCfg.mz}
                                                        onChange={(mz: string) => {
                                                            const newTeammatesConfig = cloneDeep(teammatesConfig);
                                                            newTeammatesConfig[index].mz = mz;
                                                            setTeammatesConfig(newTeammatesConfig);
                                                        }}
                                                    >
                                                        {Object.keys(teammates[tmCfg.name].mz).map(key => (
                                                            <Select.Option key={key} value={key}>{key}</Select.Option>
                                                        ))}
                                                    </Select>
                                                    <Select
                                                        prefix={'武器：'}
                                                        className={styles.select}
                                                        style={{ width: '100%' }}
                                                        value={tmCfg.weapon}
                                                        onChange={(weapon: string) => {
                                                            const newTeammatesConfig = cloneDeep(teammatesConfig);
                                                            newTeammatesConfig[index].weapon = weapon;
                                                            setTeammatesConfig(newTeammatesConfig);
                                                        }}
                                                    >
                                                        {Object.keys(teammates[tmCfg.name].weapon).map(key => (
                                                            <Select.Option key={key} value={key}>{key}</Select.Option>
                                                        ))}
                                                    </Select>
                                                    <Select
                                                        prefix={'圣遗物：'}
                                                        className={styles.select}
                                                        style={{ width: '100%' }}
                                                        value={tmCfg.syw}
                                                        onChange={(syw: string) => {
                                                            const newTeammatesConfig = cloneDeep(teammatesConfig);
                                                            newTeammatesConfig[index].syw = syw;
                                                            setTeammatesConfig(newTeammatesConfig);
                                                        }}
                                                    >
                                                        {Object.keys(teammates[tmCfg.name].syw).map(key => (
                                                            <Select.Option key={key} value={key}>{key}</Select.Option>
                                                        ))}
                                                    </Select>
                                                </>
                                            )
                                        }

                                    </div>
                                )
                            })
                        }
                        <div className={styles.title}>敌人配置</div>
                        <div className={styles.subtitle}>抗性</div>
                        <InputNumber
                            min={-20}
                            max={100}
                            value={enemyConfig.resistance}
                            onChange={resistance => setEnemyConfig({ ...enemyConfig, resistance: resistance ?? 0 })}
                            suffix={'%'}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                        <div className={styles.subtitle}>等级</div>
                        <InputNumber
                            min={0}
                            max={110}
                            value={enemyConfig.level}
                            onChange={level => setEnemyConfig({ ...enemyConfig, level: level ?? 0 })}
                            className={styles.select}
                            style={{ width: '100%' }}
                        />
                    </div>
                </Col>
                <Col xs={24} md={8}>
                    <div className={styles.card}>
                        <div className={styles.title}>面板与伤害</div>
                        <div className={styles.subtitle}>
                            面板属性
                        </div>
                        <div className={styles.line}>
                            基础攻击：{finalAttr.basicAtk}
                        </div>
                        <div className={styles.line}>
                            攻击：{finalAttr.atk}
                        </div>
                        <div className={styles.line}>
                            精通：{finalAttr.elemental}
                        </div>
                        <div className={styles.line}>
                            暴击率：{(finalAttr.criticalRate * 100).toFixed(2)}%
                        </div>
                        <div className={styles.line}>
                            暴击伤害：{(finalAttr.criticalDamage * 100).toFixed(2)}%
                        </div>
                        <div className={styles.line}>
                            重击增伤：{(finalAttr.damageRate.z * 100).toFixed(2)}%
                        </div>
                        <div className={styles.line}>
                            下落增伤：{(finalAttr.damageRate.x * 100).toFixed(2)}%
                        </div>
                        <div className={styles.line}>
                            抗性：{(finalAttr.resistance * 100).toFixed(0)}%
                        </div>
                        <div className={styles.line}>
                            防御：{finalAttr.defence.toFixed(2)}
                        </div>
                        {teammatesConfig.find(item => item.name.includes('闲云')) || yanfeiConfig.weapon.includes('溢彩') ? (
                            <>
                                <div className={styles.subtitle}>
                                    下落暴击伤害（蒸发）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.x + finalAttr.basicCount) * (1 + finalAttr.damageRate.x) * 1.5 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * (1 + finalAttr.criticalDamage)).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    下落平均伤害（蒸发）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.x + finalAttr.basicCount) * (1 + finalAttr.damageRate.x) * 1.5 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * finalAttr.criticalCount).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    下落暴击伤害（融化）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.x + finalAttr.basicCount) * (1 + finalAttr.damageRate.x) * 2 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * (1 + finalAttr.criticalDamage)).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    下落平均伤害（融化）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.x + finalAttr.basicCount) * (1 + finalAttr.damageRate.x) * 2 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * finalAttr.criticalCount).toFixed(0)}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={styles.subtitle}>
                                    重击暴击伤害（蒸发）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.z + finalAttr.basicCount) * (1 + finalAttr.damageRate.z) * 1.5 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * (1 + finalAttr.criticalDamage)).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    重击平均伤害（蒸发）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.z + finalAttr.basicCount) * (1 + finalAttr.damageRate.z) * 1.5 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * finalAttr.criticalCount).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    重击暴击伤害（融化）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.z + finalAttr.basicCount) * (1 + finalAttr.damageRate.z) * 2 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * (1 + finalAttr.criticalDamage)).toFixed(0)}
                                </div>
                                <div className={styles.subtitle}>
                                    重击平均伤害（融化）
                                </div>
                                <div className={styles.line}>
                                    {((finalAttr.atk * finalAttr.basicRate.z + finalAttr.basicCount) * (1 + finalAttr.damageRate.z) * 2 * finalAttr.elementalRate * finalAttr.resistanceRate * finalAttr.defence * finalAttr.criticalCount).toFixed(0)}
                                </div>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Yanfei;